(() => {
  const PRODUCT_HANDLE = 'hip-enhancer-padded-short';
  const DEMO_URL = 'https://cdn.shopify.com/videos/c/vp/84d064fc61c54d4ebb99b025a80b5369/84d064fc61c54d4ebb99b025a80b5369.HD-1080p-3.3Mbps-96500658.mp4';
  const BEFORE_AFTER_URL = 'https://cdn.shopify.com/videos/c/vp/51db07ace16b4f2aa2b8728fd6ca3305/51db07ace16b4f2aa2b8728fd6ca3305.HD-1080p-3.3Mbps-96500659.mp4';
  const DEMO_POSTER = 'https://cdn.shopify.com/s/files/1/1069/0474/8369/files/slynara-ref36-product-demo-poster.jpg?v=1791238971';
  const BEFORE_AFTER_POSTER = 'https://cdn.shopify.com/s/files/1/1069/0474/8369/files/slynara-ref36-before-after-poster.jpg?v=1791238977';

  const createVideoSlide = (sectionId, key, src, poster, label) => {
    const li = document.createElement('li');
    li.id = `Slide-${sectionId}-${key}`;
    li.className = 'product__media-item grid__item slider__slide slynara-ref36-video-slide';
    li.dataset.mediaId = `${sectionId}-${key}`;
    li.dataset.mediaType = 'video';
    li.dataset.slynaraRef36Video = key;
    li.innerHTML = `
      <div class="slynara-ref36-video-frame global-media-settings global-media-settings--no-shadow">
        <video
          src="${src}"
          poster="${poster}"
          muted
          loop
          playsinline
          preload="metadata"
          aria-label="${label}"
        ></video>
        <span class="slynara-ref36-video-play" aria-hidden="true">
          <svg viewBox="0 0 24 24" focusable="false"><path d="M8 5.5v13l10-6.5z"></path></svg>
        </span>
        ${key === 'ref36beforeafter' ? '<span class="slynara-ref36-comparison-label" aria-hidden="true">BEFORE</span>' : ''}
      </div>`;
    const video = li.querySelector('video');
    li.addEventListener('click', () => {
      if (video.paused) video.play().catch(() => {});
      else video.pause();
    });
    video.addEventListener('play', () => li.classList.add('is-playing'));
    video.addEventListener('pause', () => li.classList.remove('is-playing'));

    if (key === 'ref36beforeafter') {
      const label = li.querySelector('.slynara-ref36-comparison-label');
      const syncComparisonState = () => {
        if (!label || !Number.isFinite(video.duration) || video.duration <= 0) return;
        const isAfter = video.currentTime >= video.duration / 2;
        label.textContent = isAfter ? 'AFTER' : 'BEFORE';
        li.classList.toggle('is-after', isAfter);
      };
      video.addEventListener('loadedmetadata', syncComparisonState);
      video.addEventListener('timeupdate', syncComparisonState);
      video.addEventListener('seeked', syncComparisonState);
    }

    return li;
  };

  const createThumbnail = (sectionId, key, poster, label) => {
    const li = document.createElement('li');
    li.className = 'thumbnail-list__item slider__slide';
    li.dataset.target = `${sectionId}-${key}`;
    li.dataset.mediaPosition = '1';
    li.innerHTML = `
      <span class="thumbnail__badge" aria-hidden="true">
        <span class="svg-wrapper">
          <svg viewBox="0 0 24 24" focusable="false"><path d="M8 5.5v13l10-6.5z"></path></svg>
        </span>
      </span>
      <button
        class="thumbnail global-media-settings global-media-settings--no-shadow"
        type="button"
        aria-label="${label}"
        aria-controls="GalleryViewer-${sectionId}"
      >
        <img src="${poster}" alt="" loading="lazy" width="208" height="370">
      </button>`;
    return li;
  };

  const setupVideoAutoplay = (root) => {
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target;
        if (entry.isIntersecting && entry.intersectionRatio >= 0.55) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    }, { threshold: [0, 0.55, 1] });
    root.querySelectorAll('.slynara-ref36-video-slide video').forEach((video) => observer.observe(video));
  };

  const insertVideos = (productInfo) => {
    const gallery = productInfo.querySelector('media-gallery');
    if (!gallery || gallery.dataset.slynaraRef36Enhanced === 'true') return;
    const viewer = gallery.querySelector('[id^="Slider-Gallery-"]');
    if (!viewer) return;

    const sectionId = gallery.id.replace('MediaGallery-', '');
    const imageSlides = [...viewer.querySelectorAll('li[data-media-id]')].filter((slide) => slide.dataset.mediaType === 'image');
    const beigeSlides = imageSlides.filter((slide) => {
      const alt = slide.querySelector('img[alt]')?.alt || '';
      return alt.toLowerCase().includes('beige');
    });

    const demoSlide = createVideoSlide(
      sectionId,
      'ref36demo',
      DEMO_URL,
      DEMO_POSTER,
      'CurveLift Hip Enhancer Short beige product demonstration'
    );
    const beforeAfterSlide = createVideoSlide(
      sectionId,
      'ref36beforeafter',
      BEFORE_AFTER_URL,
      BEFORE_AFTER_POSTER,
      'CurveLift Hip Enhancer Short before and after silhouette demonstration'
    );

    if (beigeSlides[1]) beigeSlides[1].after(demoSlide);
    else viewer.append(demoSlide);

    if (beigeSlides.length) beigeSlides[beigeSlides.length - 1].after(beforeAfterSlide);
    else viewer.append(beforeAfterSlide);

    const thumbList = gallery.querySelector('[id^="Slider-Thumbnails-"]');
    if (thumbList) {
      const beigeTargets = new Set(beigeSlides.map((slide) => slide.dataset.mediaId));
      const beigeThumbs = [...thumbList.querySelectorAll('li[data-target]')].filter((item) => beigeTargets.has(item.dataset.target));
      const demoThumb = createThumbnail(sectionId, 'ref36demo', DEMO_POSTER, 'View product demonstration video');
      const beforeAfterThumb = createThumbnail(sectionId, 'ref36beforeafter', BEFORE_AFTER_POSTER, 'View before and after video');
      if (beigeThumbs[1]) beigeThumbs[1].after(demoThumb);
      else thumbList.append(demoThumb);
      if (beigeThumbs.length) beigeThumbs[beigeThumbs.length - 1].after(beforeAfterThumb);
      else thumbList.append(beforeAfterThumb);
      demoThumb.querySelector('button')?.addEventListener('click', () => gallery.setActiveMedia?.(`${sectionId}-ref36demo`, false));
      beforeAfterThumb.querySelector('button')?.addEventListener('click', () => gallery.setActiveMedia?.(`${sectionId}-ref36beforeafter`, false));
    }

    if (gallery.colorMedia) {
      gallery.colorMedia.groups.ref36demo = ['Beige'];
      gallery.colorMedia.groups.ref36beforeafter = [];
      gallery.colorSlides = [...viewer.children].filter((item) => item.dataset.mediaId);
      gallery.appliedColor = null;
      gallery.applyColor(gallery.colorMedia.selected);
    }

    gallery.dataset.slynaraRef36Enhanced = 'true';
    setupVideoAutoplay(gallery);
  };

  const selectBeigeByDefault = (productInfo) => {
    const url = new URL(window.location.href);
    if (url.searchParams.has('variant')) return;

    const picker = productInfo.querySelector(`variant-selects[data-product-handle="${PRODUCT_HANDLE}"]`);
    if (!picker) return;
    const beige = [...picker.querySelectorAll('input[type="radio"][data-option-name]')].find((input) => {
      return input.dataset.optionName?.toLowerCase() === 'color' && input.value.toLowerCase() === 'beige';
    });
    if (!beige || beige.checked) return;
    beige.checked = true;
    beige.dispatchEvent(new Event('change', { bubbles: true }));
  };

  const init = () => {
    const productInfo = document.querySelector(`product-info[data-product-id="11027755663697"]`);
    if (!productInfo) return;
    insertVideos(productInfo);
    window.setTimeout(() => selectBeigeByDefault(productInfo), 0);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();